// 资产状态
export const AssetStatus = {
	IN_USE: 'success',
	IDLE: 'warning',
	RENOVATION: 'primary',
	SUSPENDED: 'info',
	DISPOSED: 'danger',
};

//变动状态
export const AssetPlanStatus = {
	NOT_STARTED: 'info',
	IN_PROGRESS: 'primary',
	COMPLETED: 'success',
	TERMINATED: 'danger',
};

//变动类型
export const AssetChangeType = {
	RECEIVE_REGISTRATION: 'primary',
	ASSET_CHANGE: 'warning',
	DISPOSAL_RECORD: 'success',
};

// 合同终止类型
export const TerminationType = {
	CONTRACT_TERMINATION: 'danger',
	INTENTION_CANCEL: 'warning',
};

// 规划类型
export const PlanningType = {
	PLANNING_CONTROL: 'info',
	LEASE_OPERATION: 'primary',
	SALES_DISPOSAL: 'success',
	UPDATE_RENOVATION: 'warning',
	SELF_OPERATION: 'info',
	MULTI_OPERATION: 'primary',
	TEMPORARY_SUSPENSION: 'info',
	NON_ECONOMIC_USE: 'warning',
};

// 退费类型
export const RefundType = {
	FULL: 'success',
	PARTIAL: 'warning',
	NONE: 'danger',
};

// 租金周期
export const RentCycle = {
	MONTHLY: 'primary',
	QUARTERLY: 'info',
	HALF_YEARLY: 'warning',
	YEARLY: 'success',
	ONE_TIME: 'danger',
};

// 折旧状态
export const DepreciationStatus = {
	CALCULATING: 'info',
	COMPLETED: 'success',
	STOPPED: 'danger',
};

// 资产分类
export const AssetCategory = {
	SHOPPING_MALL: 'primary',
	PARKING_SPACE: 'info',
	AD_SPACE: 'warning',
	HOUSE: 'success',
};

// 合同状态
export const ContractStatus = {
	PENDING: 'info',
	EXECUTING: 'primary',
	EXPIRED: 'warning',
	TERMINATED: 'danger',
};

// 资源类型
export const ResourceType = {
	SHOPPING_MALL: 'primary',
	AD_SPACE: 'warning',
	VENUE: 'info',
	OTHER: 'secondary',
};

// 租赁状态
export const RentalStatus = {
	RENTED: 'success',
	AVAILABLE: 'info',
	RESERVED: 'warning',
	RENOVATING: 'primary',
};

// 合同终止状态
export const TerminationStatus = {
	PENDING: 'info',
	APPROVED: 'success',
	REJECTED: 'danger',
};

// 合同类型
export const ContractType = {
	CONTRACT: 'primary',
	INTENTION: 'info',
};

// 缴费状态
export const PaymentStatus = {
	UNPAID: 'warning',
	PAID: 'success',
	OVERDUE: 'danger',
};

// 退款方式
export const RefundMethod = {
	ORIGINAL: 'primary',
	BANK_TRANSFER: 'info',
	CASH: 'warning',
};
